<template>

  <div class="navigation h100">
    <div class="navcont h100" :class="{isOpen: isOpen}">
      <div class="navtable h100">
        <div class="navrow h100">
          <div class="navcell h100">
            <div class="close-btn only-mobile">
              <button
                  @click.prevent="closeNav"
                  class="navToggle hamburger hamburger--boring is-active"
                  type="button">
                  <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                  </span>
                </button>
            </div>
            <h2 class="link" ref="firstElement" @click.prevent="toTop()">Tim Vogt</h2>
            <ul class="nav">
              <main-navigation-item v-for="item in Content" :key="item.name" :item="item" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Content from '../store/content';
import MainNavigationItem from './navigation/MainNavigationItem'

export default {
  name: 'Navigation',
  data() {
    return {
      Content,
      isOpen: false
    }
  },
  mounted() {
    this.$bus.$on('getTopNavSpace', () => {
      const winWidth = window.innerWidth;
      if (winWidth < 770) {
        this.$bus.$emit('setTopNavSpace', { top: 90, height: 0 })
      } else {
        const top = this.$refs.firstElement.offsetTop;
        const height = this.$refs.firstElement.offsetHeight;
        this.$bus.$emit('setTopNavSpace', { top, height })
      }
    });
    this.$bus.$on('toggleNav', (data) => {
      this.isOpen = data.isOpen;
    });
  },
  methods: {
    toTop() {
      this.$bus.$emit('navigateTo', { name: 'start' });
      this.$bus.$emit('toggleNav', { isOpen: false });
    },
    closeNav() {
      this.$bus.$emit('toggleNav', { isOpen: false })
    }
  },
  components: {
    MainNavigationItem
  }
}
</script>

<style lang="sass">

.link
  cursor: pointer

.navigation
  // height: 100%
  // width: 100%
  // perspective: 600px

.navcont
  position: fixed

  @media screen and (max-width: 769px)
    top: 0
    left: 0
    right: 0
    borrom: 0
    padding: 40px
    z-index: 5
    background-color: rgba(255,255,255,.97)

    transform: translateX(-100%) //rotateY(90deg);
    transform-style: preserve-3d
    transform-origin: right
    transition: transform 300ms ease-out

    &.isOpen
      transform: translateX(0)//rotateY(0deg);

  .navtable
    display: table
    width: 100%

    .navrow
      display: table-row

      .navcell
        display: table-cell
        vertical-align: middle
        text-align: right

        ul
          padding: 0

          li
            list-style-type: none

#nav
  padding: 30px

  a
    font-weight: bold
    color: #2c3e50

    &.router-link-exact-active
      color: #42b983

.close-btn
  position: absolute
  top: 0
  right: 0
  z-index: 10
</style>
